export function isReferralCandidate(details) {
  if (!details || typeof details !== 'object') return false;
  const v = details.referral_candidate;
  if (typeof v !== 'string' || v === '') return false;
  return v.toLowerCase() === 'yes';
}
